import { render, staticRenderFns } from "./SurgeryInvoice.vue?vue&type=template&id=636e1b9c&scoped=true"
import script from "./SurgeryInvoice.vue?vue&type=script&lang=js"
export * from "./SurgeryInvoice.vue?vue&type=script&lang=js"
import style0 from "./SurgeryInvoice.vue?vue&type=style&index=0&id=636e1b9c&prod&scoped=true&lang=css"
import style1 from "./SurgeryInvoice.vue?vue&type=style&index=1&id=636e1b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e1b9c",
  null
  
)

export default component.exports